import { useEffect, useState } from "react"

import { ContainerScreenGeneral } from "../../components"

import {
    screen_dic,
    initialState,
    initialDataState,
    unMount,
} from "./handlers"

import UserRoleForm from "./UserRoleForm"
import UserPermissionForm from "./UserPermissionForm"
import RolesPermissionForm from "./RolesPermissionForm"

const Permissions = () => {
    // const nav = useNavigate()

    // Configuracion de estados internos.
    const [state, setState] = useState({ ...initialState })

    // Toda la informacion obtenida del backend, sin procesar para la vista
    const [data, setData] = useState({ ...initialDataState })

    useEffect(() => {
        unMount(setData, setState)
    }, [])

    return (
        <ContainerScreenGeneral titulo={"Notificadores"} linkBack={'/'} >
            <div
            className="card mb-2 d-flex flex-row p-2"
            // <div
                // className={{ container: "card mb-2 d-flex flex-row p-2" }}
                // nav={nav}
            >
                <h3 className='m-0 ms-2'>
                    Configuración de roles y permisos -{" "}
                    {screen_dic[state.screen]}
                </h3>
            </div>
            {/* </BackContainer> */}
            <hr />
            <div className='d-flex justify-content-center gap-3'>
                {Object.keys(screen_dic).map((key, _key) => (
                    <button
                        className='btn btn-primary btn-sm fs-6'
                        key={_key}
                        disabled={key === state.screen || state.loading}
                        onClick={() =>
                            setState((state) => ({
                                ...state,
                                screen: key,
                                role: null,
                                user: null,
                            }))
                        }
                    >
                        {(screen_dic)[key]}
                    </button>
                ))}
            </div>
            <hr />

            <UserRoleForm
                stateContext={{ state, setState }}
                dataContext={{ data, setData }}
                show={state.screen === "user_roles"}
            />

            <UserPermissionForm
                stateContext={{ state, setState }}
                dataContext={{ data, setData }}
                show={state.screen === "user_permissions"}
            />

            <RolesPermissionForm
                stateContext={{ state, setState }}
                dataContext={{ data, setData }}
                show={state.screen === "roles_permissions"}
            />
        </ContainerScreenGeneral>
    )
}

export default Permissions
